import React, { useState } from "react";
import "./Header.css";
import logo from "../../assets/LORETECH.LS 3.png";

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="header">
      {/* LOGO */}
      <div className="header-logo">
        <img src={logo} alt="LORETECH.LS" />
      </div>

      {/* MENU */}
      <nav className={`header-nav ${menuOpen ? "active" : ""}`}>
        <a href="#servicos">Serviços</a>
        <a href="#solucoes">Soluções</a>
        <a href="#contato">Contato</a>

        {/* Botão Mobile */}
        <a
          href="https://wa.me/5511988833017"
          className="header-btn-mobile"
          target="_blank"
        >
          Fale com um especialista →
        </a>
      </nav>

      {/* BOTÃO DESKTOP */}
      <a
        href="https://wa.me/5511988833017"
        className="header-btn"
        target="_blank"
      >
        Fale com um especialista →
      </a>

      {/* HAMBURGER */}
      <div
        className={`header-hamburger ${menuOpen ? "open" : ""}`}
        onClick={() => setMenuOpen(!menuOpen)}
      >
        <span></span>
        <span></span>
        <span></span>
      </div>
    </header>
  );
}

export default Header;
